<script lang="ts">
  // The operator's privacy, terms and support links, at the foot of every
  // page; nothing at all when none is configured.
  import { operatorLinks } from '../logic/operatorLinks';
  import { session } from '../state/session.svelte';

  const links = $derived(operatorLinks(session.operatorLinks));
</script>

{#if links.length}
  <footer class="operator-links">
    {#each links as link (link.label)}
      <a href={link.href} target={link.newTab ? '_blank' : undefined} rel="noreferrer" data-external>{link.label}</a>
    {/each}
  </footer>
{/if}
